import styled, { css } from 'styled-components';
import { breakpoints, font, popeyesNeutral } from 'styles';
import { IMenuRestaurantStyles } from './interfaces';

export const Container = styled.div`
  width: 100%;
  height: fit-content;
  position: relative;
  padding: 20px 50px;

  overflow: auto;

  @media (max-width: ${breakpoints.intermediary}) {
    padding: 10px 10px 75px;
  }
`;

export const MenuCategoryContainer = styled.div<IMenuRestaurantStyles>`
  display: flex;
  flex-direction: column;
  width: 100%;

  > span {
    margin: 40px 0;
    font-size: ${font.sizes.textLarge};
    color: ${popeyesNeutral.neutral09};

    @media (min-width: ${breakpoints.intermediary}) {
      padding-left: 80px;
    }
  }
`;

export const MenuCategoryItem = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  flex: 1;
  max-width: 100%;

  @media (max-width: ${breakpoints.intermediary}) {
    max-width: 100%;
    min-width: 100%;
  }

  @media (min-width: ${breakpoints.intermediary}) {
    margin-left: 5%;
  }
`;

export const MenuitemContainer = styled.div`
  max-width: 1280px;
  min-width: 1130px;

  margin: 10px 20px 0px 20px;
  margin: 0 auto;

  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${breakpoints.intermediary}) {
    max-width: 100%;
    min-width: 100%;
    margin: 10px 10px 0px;
  }

  @media (max-width: ${breakpoints.large}) {
    margin: 20px auto 0px;
  }
`;

export const StatusContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  span {
    margin: 0 5px;
    @media (max-width: ${breakpoints.intermediary}) {
      font-size: ${font.sizes.textSmall};
    }
  }
`;

export const ChooseRestaurant = styled.div<IMenuRestaurantStyles>`
  display: ${props => (props.hideButton ? 'none' : 'flex')};
  position: fixed;
  bottom: 20px;
  width: 300px;
  font-size: ${font.sizes.textXSmall};
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;

  @media (max-width: ${breakpoints.intermediary}) {
    width: 80%;
  }
`;
